import {
    fetchTemplates
} from '../dashboardSlice';

export default function ssrFetch({
    store, headers, baseUrl, timeout
}) {
    const options = timeout ? {timeout} : {};

    return store.dispatch(fetchTemplates({headers, baseUrl, options}));
}
